import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Home from '../views/Home.vue';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    redirect: '/index',
    name: 'Home',
    component: Home,
    children: [
      {
        path: 'index',
        name: 'Index',
        component: () =>
          import(/* webpackChunkName: "index" */ '../views/index.vue'),
      },
      {
        path: 'recruitmentList',
        name: 'RecruitmentList',
        component: () =>
          import(
            /* webpackChunkName: "index" */ '../views/recruitmentList.vue'
          ),
      },
      {
        path: 'recruitmentDetail',
        name: 'recruitmentDetail',
        component: () =>
          import(
            /* webpackChunkName: "index" */ '../views/recruitmentDetail.vue'
          ),
      },
    ],
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/About.vue'),
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  // if (to.matched.some(r => r.meta.requireAuth)) { // 判断该路由是否需要登录权限
  //     // if (store.state.token) {
  //     //     next();
  //     // } else {
  //     //     next({
  //     //         path: '/login',
  //     //         query: {redirect: to.fullPath}
  //     //     })
  //     // }
  // } else {
  next();
  // }
});

export default router;
